






























































































import { ShowCaseFinProductVueGB } from "@/extensions/products/ShowCaseFinProductVueGB";
import BackLink from "@/components/app/BackLink.vue";
import Preloader from "@/components/app/Preloader.vue";
import { Component } from "vue-property-decorator";

@Component({
  components: { BackLink, Preloader }
})
export default class ShowCaseFinProduct extends ShowCaseFinProductVueGB {

  async mounted(): Promise<void> {
  	this.init();
  }

	isVisible = false;
	toggle(): void {
    this.isVisible = !this.isVisible;
  }

}
